import { ContentStoreCategoriesService } from 'src/services/Categories';

export const createCategory = async (
    { accessToken, category }: App.Category.CreateMutationVariables,
): Promise<Models.ContentStoreApi.V3.Category> => ContentStoreCategoriesService.createCategory(accessToken, category);
